export default __webpack_public_path__ + "static/media/3d-origami.e799c775.jpeg";